import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useWidget } from "/imports/state/WidgetContext";
import { useAuth } from "/imports/state/AuthContext";
import { useUrlFilters } from "/imports/libs/url";
import api from "/imports/api/client";

export default function useTrainerClaim() {
  const navigate = useNavigate();
  const { slug } = useWidget();
  const { trainerClaim, error: authError, clearError } = useAuth();
  const { filters } = useUrlFilters({});

  const [step, setStep] = useState("code");
  const [code, setCode] = useState("");
  const [prefill, setPrefill] = useState(null);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [errorCode, setErrorCode] = useState(null);

  const query = filters.redirect ? `?redirect=${filters.redirect}` : "";
  const loginTo = `/${slug}/login${query}`;

  const handleBack = () => {
    if (step === "password") {
      setStep("code");
      return;
    }
    navigate(`/${slug}/signup${query}`);
  };

  const handleCodeChange = (e) => {
    setCode(e.target.value.toUpperCase());
    setError(null);
    setErrorCode(null);
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    setError(null);
    setErrorCode(null);
    clearError();

    if (!code.trim()) {
      setError("Please enter your access code");
      return;
    }

    setLoading(true);
    try {
      const data = await api.trainerClaimVerify(code.trim(), slug);
      setPrefill(data.trainer);
      setStep("password");
    } catch (err) {
      setError(err.message || "We couldn't verify this code. Please try again.");
      setErrorCode(err.code || null);
    } finally {
      setLoading(false);
    }
  };

  const handleClaim = async (e) => {
    e.preventDefault();
    setError(null);
    setErrorCode(null);
    clearError();

    if (!password) {
      setError("Please choose a password");
      return;
    }
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }
    if (password.length < 6) {
      setError("Password must be at least 6 characters");
      return;
    }

    setLoading(true);
    try {
      await trainerClaim({ code: code.trim(), slug, password });
      navigate(`/${slug}/trainer`);
    } catch (err) {
      setError(err.message || "We couldn't complete your sign-in. Please try again.");
      setErrorCode(err.code || null);
    } finally {
      setLoading(false);
    }
  };

  return {
    step,
    setStep,
    code,
    prefill,
    password,
    setPassword,
    confirmPassword,
    setConfirmPassword,
    showPassword,
    setShowPassword,
    showConfirmPassword,
    setShowConfirmPassword,
    loading,
    error,
    errorCode,
    authError,
    loginTo,
    handleBack,
    handleCodeChange,
    handleVerify,
    handleClaim
  };
}
